import React from 'react';
import { ReactComponent as Motor } from '../../../assets/images/icons/Motor.svg';
import { ReactComponent as Connect } from '../../../assets/images/icons/Connect.svg';
import { ReactComponent as Gear } from '../../../assets/images/icons/Gear.svg';
import { ReactComponent as ConnectBlue } from '../../../assets/images/icons/Connect-blue.svg';
import { ReactComponent as Pump } from '../../../assets/images/icons/Pump.svg';

export enum IconType {
    Motor,
    Connect,
    ConnectBlue,
    Gear,
    Pump
}

interface IconProps {
    type: IconType;
}

const Icon = ({ type }: IconProps) => {
    switch (type) {
        case IconType.Motor:
            return <Motor />;
        case IconType.Connect:
            return <Connect />;
        case IconType.ConnectBlue:
            return <ConnectBlue />;
        case IconType.Gear:
            return <Gear />;
        case IconType.Pump:
            return <Pump />;
    }
};

export default Icon;
